import styled from 'styled-components'
import { OrderStatus } from '../../../../enums/order.enum'
import { orderColors, orderLightColors } from '../../../../helpers/helper-order'
import { theme } from '../../../../styles/theme'

interface IStatus {
  code: 0 | 1 | 2;
}

interface IContainer extends IStatus {
  selected: boolean;
}

export const Container = styled.li<IContainer>`
  width: 100%;
  height: 86px;
  padding: 15px;

  background-color: ${({ selected }) => (
    selected ? theme.colors.secondLightGray : theme.colors.mainBg
  )};
  border-radius: ${theme.border.normal};
  border-left: 4px solid ${({ selected, code }) => (
    selected ? orderColors[code] : orderLightColors[code]
  )};
  box-shadow: 0px 6px 15px rgba(37, 42, 49, 0.1);

  display: flex;
  justify-content: space-between;
  align-items: center;

  cursor: ${({ code }) => (code !== OrderStatus.WITHOUT_ORDER ? 'pointer' : 'not-allowed')};

  & > div {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    gap: 10px;

    & > p {
      margin: 0px;

      font-family: ${theme.font.inter};
      font-weight: ${theme.font.medium};
      font-size: ${theme.font.sizes.small};
      line-height: ${theme.font.sizes.normal};
      color: ${theme.colors.black};
    }
  }
`

export const Status = styled.span<IStatus>`
  padding: 8px;

  background: ${({ code }) => orderLightColors[code]};
  border-radius: ${theme.border.smallRadius};
  font-family: ${theme.font.inter};
  font-weight: ${theme.font.normal};
  font-size: ${theme.font.sizes.xxsmall};
  line-height: ${theme.font.sizes.xsmall};
  color: ${({ code }) => orderColors[code]};
`

export const RightWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;

  & > span {
    font-family: ${theme.font.inter};
    font-weight: ${theme.font.normal};
    font-size: ${theme.font.sizes.xxsmall};
    line-height: ${theme.font.sizes.xsmall};
    color: #828282;
  }

  & > strong {
    font-family: ${theme.font.inter};
    font-weight: ${theme.font.normal};
    font-size: ${theme.font.sizes.xsmall};
    line-height: ${theme.font.sizes.xsmall};
    color: ${theme.colors.red};
  }
`
